.#{$namespace}-input {
	position: relative;
	box-sizing: border-box;
	width: 100%;
	padding-block: 0;
	padding-inline: calc($control-height * 0.45);
	display: inline-flex;
	align-items: center;
	border: 1px solid $border-color;
	border-radius: 8px;
	background-color: $white-color;
	overflow: hidden;
	height: $control-height;
	input {
		flex: 1;
		min-width: 0; // 原生 input 默认 min-width:auto，不设会伸到 suffix 底下，点验证码其实点到 input
		height: 100%;
		border: none;
		outline: none;
		background: transparent;
		font-size: $font-size;
		&[type='number'] {
			-moz-appearance: textfield;
			appearance: textfield;
			&::-webkit-outer-spin-button,
			&::-webkit-inner-spin-button {
				-webkit-appearance: none;
				margin: 0;
			}
		}
	}
	.prefix,
	.suffix {
		position: relative;
		display: flex;
		align-items: center;
		width: auto;
		min-width: 20px;
		cursor: auto;
		font-size: $font-size;
		.icon {
			transform: translateY(-2px);
		}
	}
	.prefix {
		margin-right: 5px;
	}
	.suffix {
		z-index: 1; // 叠在 input 之上，保证点到的是 suffix 而不是被 flex 撑过来的 input
		flex-shrink: 0;
		margin-left: 5px;
		font-size: $font-size;
		.suffix-action {
			position: relative;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			line-height: 0;
			// 跟 Select .select-skill 一样只占一格；不清空脱离文档流就会和日历并排
			&.is-cover .icon.close {
				position: absolute;
				inset: 0;
				// 盖掉同文件 .icon.close { height: 1em }，否则 inset 撑不满 20px 日历
				width: auto;
				height: auto;
				display: flex;
				align-items: center;
				justify-content: center;
				background-color: $white-color;
				transform: none;
			}
		}
		.icon {
			&.close,
			&.password {
				height: 1em;
				pointer-events: none;
				opacity: 0;
				color: $text-placeholder-color;
				cursor: pointer;
				&:hover {
					color: color-token(danger);
				}
			}
			&.password {
				opacity: 1;
				pointer-events: auto;
				&:hover {
					color: color-token(primary);
				}
			}
		}
		.count {
			margin-left: 4px;
			font-size: calc(#{$font-size} - 2px);
			color: $text-placeholder-color;
			white-space: nowrap;
		}
	}
	.prepend,
	.append {
		display: inline-flex;
		align-items: center;
		padding: 0 12px;
		background: color-token(info, light-9);
		color: $text-secondary-color;
		white-space: nowrap;
		font-size: $font-size;
	}
	.prepend {
		margin-right: 8px;
		border-right: 1px solid $border-color;
	}
	.append {
		margin-left: 8px;
		border-left: 1px solid $border-color;
	}
	&.is-focus,
	&:hover {
		&:not(.is-disabled) {
			.suffix {
				.icon {
					&.close {
						cursor: pointer;
						pointer-events: auto;
						opacity: 1;
					}
				}
			}
		}
	}
	&.is-focus {
		border-color: color-token(primary);
	}
	&.is-disabled {
		// 禁用只锁交互 / 字色；另写底会盖掉业务 white-color-3，整表 loading 时像抽空
		cursor: not-allowed;
		input {
			cursor: not-allowed;
			pointer-events: none;
			color: $text-placeholder-color;
		}
	}
	&--large {
		height: calc(#{$control-height} + 8px);
		padding-inline: calc((#{$control-height} + 8px) * 0.45);
	}
	&--small {
		height: calc(#{$control-height} - 8px);
		padding-inline: calc((#{$control-height} - 8px) * 0.45);
		font-size: calc(#{$font-size} - 2px);
		input {
			font-size: calc(#{$font-size} - 2px);
		}
	}
}
